import React from 'react';
import './css_components/Footer.css';

export default function Footer() {
  return (
    <footer
      className="text-center text-lg-start text-white"
      style={{ backgroundColor: '#1c2331' }}
    >
      {/* Social section */}
      <section
        className="d-flex justify-content-between p-4 connect-us"
        style={{ backgroundColor: '#2c3a50' }}
      >
        
        <div className="me-5 mx-5 c-title">
          <span>Get connected with us on social networks:</span>
        </div>

        <div className='mx-5'>
          <a href="https://facebook.com/inkmudra" className="text-white me-4">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="mailto:inkmudra25@gmail.com" className="text-white me-4">
            <i className="fas fa-envelope"></i>
          </a>
          <a href="https://facebook.com/inkmudra" className="text-white me-4">
            <i className="fab fa-google"></i>
          </a>
          <a href="https://instagram.com/inkmudra" className="text-white me-4">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://facebook.com/inkmudra" className="text-white me-4">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href="https://facebook.com/inkmudra" className="text-white me-4">
            <i className="fab fa-github"></i>
          </a>
        </div>
      </section>

      {/* Main footer links */}
      <section className='main-footer'>
        <div className="container text-center text-md-start mt-5 mx-5" style={{display: "contents"}}>
          
          <div className="row mt-3 mx-5" style={{display: "flex", justifyContent: "space-between"}}>

            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
              <h3 className="text-uppercase fw-bold">InkMudra</h3>
              <hr
                className="mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: '60px', backgroundColor: '#7c4dff', height: '2px' }}
              />
              <p>
                Design to doorstep: premium prints without the hassle.
              </p>
            </div>

            <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              {/* <h6 className="text-uppercase fw-bold">Products</h6>
              <hr
                className="mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: '60px', backgroundColor: '#7c4dff', height: '2px' }}
              />
              <p><a href="#!" className="text-white">Documents</a></p>
              <p><a href="#!" className="text-white">Business Cards</a></p>
              <p><a href="#!" className="text-white">Posters</a></p>
              <p><a href="#!" className="text-white">Blackbooks</a></p> */}
            </div>

            <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
              <h6 className="text-uppercase fw-bold">Useful links</h6>
              <hr
                className="mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: '60px', backgroundColor: '#7c4dff', height: '2px' }}
              />
              <p><a href="#!" className="text-white">Terms and Conditions<br/>Privacy Policy</a></p>
              <p><a href="#!" className="text-white">Cancellation Policy</a></p>
              <p><a href="/products" className="text-white">Products</a></p>
              {/* <p><a href="#!" className="text-white">Contact Us</a></p> */}
              
              
            </div>

            <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold">Contact</h6>
              <hr
                className="mb-4 mt-0 d-inline-block mx-auto"
                style={{ width: '60px', backgroundColor: '#7c4dff', height: '2px' }}
              />
              <p><i className="fas fa-home mr-3"></i> Charni Road, Mumbai - 400004</p>
              <p><a href="mailto:inkmudra25@gmail.com"><i className="fas fa-envelope mr-3"></i> inkmudra25@gmail.com</a></p>
              <p><a href="tel:+919321993958"><i className="fas fa-phone mr-3"></i> +91 9321993958</a></p>
              <p><a href="tel:+917020277681"><i className="fas fa-print mr-3"></i> +91 7020277681</a></p>
            </div>

          </div>
        </div>
      </section>

      {/* Footer bottom */}
      <div
        className="text-center p-3"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
      >
        © 2024 Copyright: 
        <a className="text-white ms-1" href="https://mdbootstrap.com/">InkMudra.in</a>
      </div>
    </footer>
  );
}
